import { useT } from "../lib/i18n";
import { hapticSelect } from "../lib/haptics";
import { SLOT_ORDER } from "../lib/meals";
import type { MealSlot } from "@shared/types";

interface Props {
  value: MealSlot;
  onChange: (slot: MealSlot) => void;
}

/** Segmented pill picker over the four meal slots. Presentational only. */
export function MealSlotPicker({ value, onChange }: Props) {
  const t = useT();
  return (
    <div className="flex gap-1.5">
      {SLOT_ORDER.map((slot) => {
        const active = slot === value;
        return (
          <button
            key={slot}
            type="button"
            onClick={() => { hapticSelect(); onChange(slot); }}
            className={`flex-1 py-3 rounded-xl text-sm font-medium transition-colors ${
              active ? "bg-success text-on-primary" : "bg-surface text-fg-secondary active:bg-surface-strong"
            }`}
          >
            {t(`meal.header.${slot}`)}
          </button>
        );
      })}
    </div>
  );
}
